import { v4 as uuid } from 'uuid';
import { DeedDocumentType } from './DeedDocumentType';
import { EstateType } from './EstateType';

export interface IRecordedDeed {
  consideration: number | null;
  grantee: string | null;
  grantor: string | null;
  document_type: DeedDocumentType | null;
  other_document_type: string | null;
  id: string;
  instrument_number: string | null;
  book: string | null;
  recorded_date: string | null;
  execution_date: string | null;
  recorded_at: string | null;
  estate_type: EstateType | null;
  existing: boolean;
}

export interface IRecordedDeedRequired {
  consideration: boolean;
  grantee: boolean;
  grantor: boolean;
  document_type: boolean;
  other_document_type: boolean;
  instrument_number: boolean;
  book: boolean;
  recorded_date: boolean;
  execution_date: boolean;
  recorded_at: boolean;
  estate_type: boolean;
  existing: boolean;
}

export const constructNewRecordedDeed = ({
  id = uuid(),
  instrument_number = null,
  book = null,
  recorded_date = null,
  recorded_at = null,
  execution_date = null,
  estate_type = null,
  consideration = null,
  grantee = null,
  grantor = null,
  document_type = null,
  other_document_type = null,
  existing = false,
}: Partial<IRecordedDeed> = {}) => ({
  id,
  instrument_number,
  book,
  recorded_date,
  recorded_at,
  execution_date,
  estate_type,
  consideration,
  grantee,
  grantor,
  document_type,
  other_document_type,
  existing,
});
